import React from 'react';
import { Card, CardBody, CardTitle } from 'reactstrap';
import { toast } from 'react-toastify';
import EditableLabelWithPencilIcon from '../atoms/EditableLabelWithPencilIcon.js';
import moment from 'moment';

const UserInfoSection = ({ user, quoteToolClient, onUpdate }) => {
    const handleFieldUpdate = async ({ field, value }) => {
        try {
            const updatedUser = await quoteToolClient.patchUser({
                userId: user.id,
                patch: { [field]: value }
            });
            onUpdate(updatedUser);
            toast.success(`${field} updated successfully`);
        } catch (error) {
            console.error(`Error updating ${field}:`, error);
            toast.error(`Failed to update ${field}`);
            throw error;
        }
    };

    return (
        <Card>
            <CardBody>
                <CardTitle tag="h5">User Information</CardTitle>

                <div className="user-info-field">
                    <label>Email</label>
                    <div className="user-info-field-value">
                        <EditableLabelWithPencilIcon
                            defaultValue={user.email}
                            handleNewValue={(value) => handleFieldUpdate({ field: 'email', value })}
                            placeholderValue="No email"
                        />
                    </div>
                </div>

                <div className="user-info-field">
                    <label>First Name</label>
                    <div className="user-info-field-value">
                        <EditableLabelWithPencilIcon
                            defaultValue={user.firstName}
                            handleNewValue={(value) => handleFieldUpdate({ field: 'firstName', value })}
                            placeholderValue="No first name"
                        />
                    </div>
                </div>

                <div className="user-info-field">
                    <label>Last Name</label>
                    <div className="user-info-field-value">
                        <EditableLabelWithPencilIcon
                            defaultValue={user.lastName}
                            handleNewValue={(value) => handleFieldUpdate({ field: 'lastName', value })}
                            placeholderValue="No last name"
                        />
                    </div>
                </div>

                <div className="user-info-field">
                    <label>Created</label>
                    <div className="user-info-field-value">
                        <span>{moment(user.created).format('MMMM D, YYYY h:mm A')}</span>
                    </div>
                </div>

                <div className="user-info-field">
                    <label>Last Active</label>
                    <div className="user-info-field-value">
                        <span>{user.lastActive ? moment(user.lastActive).format('MMMM D, YYYY h:mm A') : 'Never'}</span>
                    </div>
                </div>

                <div className="user-info-field">
                    <label>Last Modified</label>
                    <div className="user-info-field-value">
                        <span>{user.lastModified ? moment(user.lastModified).format('MMMM D, YYYY h:mm A') : 'Never'}</span>
                    </div>
                </div>
            </CardBody>
        </Card>
    );
};

export default UserInfoSection;
